import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import { DateTime } from 'luxon'
import { Address, PlaceDetail } from '@/models/dto'
import AutoCompleteAddress from '@/components/AutoCompleteAddress.vue'
import SalesBotItineraryStopKeepOnSite from '@/components/SalesBotItineraryStopKeepOnSite.vue'
import SalesBotItineraryStopDatetime from '@/components/SalesBotItineraryStopDatetime.vue'
import CUIcon from '@/components/CUIcon.vue'
import { secondsToFormattedDuration } from '@/utils/datetime'
import { placeDetailToAddress } from '../utils/address'
import { estimateDropoffDatetime } from '@/utils/stop'
import { PropType } from 'vue/types/v3-component-props'
import { SalesBotV2Address, SalesBotV2Stop } from '@/models/SalesbotV2Quote'
import deepClone from '@/utils/deepClone'
import { LatLng } from '@/models/LatLng'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotItineraryStop',
  props: {
  stop: {
    type: Object as PropType<SalesBotV2Stop>,
    required: true,
    default: null,
  },
  stopTypeLabel: {
    type: String as PropType<'Stop' | 'Pickup' | 'Dropoff'>,
    required: true,
  },
  errorMessage: {
    type: String as PropType<string>,
    default: '',
  },
  hideDelete: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  },
  hideAdd: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  },
  index: {
    type: Number as PropType<number>,
    required: true,
  },
  isLastStop: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  showKeepOnSite: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  },
  vehicleNeededEntireTrip: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  },
  minimumDatetime: {
    type: Object as PropType<DateTime>,
    required: true,
  },
  arrivalText: {
    type: String as PropType<string>,
    required: false,
  },
  biasCoordinate: {
    type: Object as PropType<LatLng>,
    required: false,
  },
  hasIncompleteAddress: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  }
},
  emits: ['stop:delete', 'stop:add', 'stop:update', 'vehicle-needed-entire-trip:update'],
  setup(__props, { emit }) {

const props = __props;





const addressName = computed<string>(() => props.stop?.address?.name ?? '')

const onAddressUpdate = (place: PlaceDetail): void => {
  const address: SalesBotV2Address | null = place ? {
      name: place.addressName,
      city: place.city,
      country: place.country,
      lat: place.lat,
      lng: place.lng,
      postalCode: place.postalCode,
      state: place.state,
      street1: place.street1,
      title: place.title,
      addressTypeKeys: place.types,
      zoneId: place.timeZone,
  } : null

  const updatedStop: SalesBotV2Stop = { ...props.stop, address }
  emit('stop:update', updatedStop)
}

const onDatetimeUpdate = (datetime: DateTime): void => {
  const updatedStop: SalesBotV2Stop = { ...props.stop, pickupDatetime: datetime }
  emit('stop:update', updatedStop)
}


return { __sfc: true,props, emit, addressName, onAddressUpdate, onDatetimeUpdate, AutoCompleteAddress, SalesBotItineraryStopKeepOnSite, SalesBotItineraryStopDatetime }
}

})